module.exports = __webpack_public_path__ + "media/highclass/service-process-pc-74f7b5dd.svg";